import React, { createContext, useState, useContext } from "react";

const ProductContext = createContext();

export const useProductContext = () => useContext(ProductContext);

export const ProductProvider = ({ children }) => {
  const [productData, setProductData] = useState({});
  const [faqSection, setFaqSection] = useState([]);

  const [previewMode, setPreviewMode] = useState(false);
  const updateProductData = (sku, component, newData) => {
    setProductData((prev) => ({
      ...prev,
      [sku]: {
        ...(prev[sku] || {}),
        [component]: newData,
      },
    }));
  };

  return (
    <ProductContext.Provider
      value={{
        productData,
        updateProductData,
        previewMode,
        setPreviewMode,
        faqSection,
        setFaqSection,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
